'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var inputStyle = function (key) { return styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    height: ", ";\n    border-radius: ", ";\n    line-height: ", ";\n"], ["\n    height: ", ";\n    border-radius: ", ";\n    line-height: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme[key].height;
}, function (_a) {
    var theme = _a.theme;
    return theme[key].borderRadius;
}, function (_a) {
    var theme = _a.theme;
    return theme[key].lineHeight;
}); };
var textInputs = {
    roundedCornersInputs: {
        height: '40px',
        lineHeight: '30px',
        borderRadius: '3px',
    },
    squaredCornersInputs: {
        height: '48px',
        lineHeight: '30px',
        borderRadius: '0',
    },
};
var TextInput = styled__default['default'].input.withConfig({ displayName: "ww-uikit_TextInput_lb1ysdjp", componentId: "sc-15j17qc" })(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var inputType = _a.inputType;
    return inputStyle(inputType);
});
var templateObject_1, templateObject_2;

exports.TextInput = TextInput;
exports.default = textInputs;
exports.inputStyle = inputStyle;
//# sourceMappingURL=index.js.map
